import type { User, Unit } from '../models/data';
import type { RulesAccessProfile } from '../../ui/hooks/useAppAccessProfile';
import { offlineKey, offlineActorKey, readOffline, writeOffline, readOfflineGrant } from './schedulerOfflineStore';
export type OfflineShell = { user: User; effectiveUser: User; profile: RulesAccessProfile | null; units: Unit[] };
const shellKey = (uid: string) => offlineKey('shell', uid, 'dashboard');
export function rememberOfflineShell(value: OfflineShell): void {
  if (!value.user.authUid || value.user.authUid !== value.effectiveUser.authUid || !offlineActorKey(value.effectiveUser)) return;
  const units = value.units.filter(unit => readOfflineGrant(value.effectiveUser, unit.id));
  if (!units.length) return;
  writeOffline(shellKey(value.user.authUid), { ...value, units });
}
export function readOfflineShell(uid: string): OfflineShell | null {
  const value = readOffline<OfflineShell>(shellKey(uid));
  if (!value || value.user?.authUid !== uid || value.effectiveUser?.authUid !== uid || value.user.id !== value.effectiveUser.id || (value.user as User & { active?: boolean; isActive?: boolean }).active === false || (value.user as User & { isActive?: boolean }).isActive === false || value.profile?.disabled || value.profile?.suspended || value.profile?.authorityStatus === 'denied' || !Array.isArray(value.units)) return null;
  const units = value.units.filter(unit => readOfflineGrant(value.effectiveUser, unit.id));
  return units.length ? { ...value, units } : null;
}
